import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProductCard, { Product } from './ProductCard';

const API_URL = '';
const ITEMS_PER_PAGE = 24;

const Recommended: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [searchParams] = useSearchParams();
  const search = searchParams.get('search') || '';

  const fetchProducts = async (currentOffset: number, query: string) => {
    setLoading(true);
    try {
      let url = `${API_URL}/api/storefront/list?limit=${ITEMS_PER_PAGE}&offset=${currentOffset}&published=1`;
      if (query) url += `&search=${encodeURIComponent(query)}`;
      const res = await fetch(url);
      const data = await res.json();
      if (data.products && data.products.length > 0) {
        setProducts(prev => currentOffset === 0 ? data.products : [...prev, ...data.products]);
        setHasMore(data.hasMore);
        setTotal(data.total || 0);
      } else {
        if (currentOffset === 0) setProducts([]);
        setHasMore(false);
        setTotal(data.total || 0);
      }
    } catch (err) {
      console.error('Failed to fetch products:', err);
    }
    setLoading(false);
  };

  useEffect(() => {
    setProducts([]);
    setOffset(0);
    setHasMore(true);
    fetchProducts(0, search);
  }, [search]);

  const handleMore = () => {
    const newOffset = offset + ITEMS_PER_PAGE;
    setOffset(newOffset);
    fetchProducts(newOffset, search);
  };

  return (
    <div className="recommended">
      {search && (
        <div style={{ padding: '12px 0', fontSize: 15, color: '#666' }}>
          "<b>{search}</b>" 검색 결과: <b>{total}</b>개
          {total === 0 && !loading && <span style={{ marginLeft: 12, color: '#999' }}>검색 결과가 없습니다.</span>}
        </div>
      )}
      <div className="products-grid">
        {products.map(p => (
          <ProductCard key={p.id} product={p} />
        ))}
      </div>
      {loading && <div style={{ textAlign: 'center', padding: 20, color: '#999' }}>로딩 중...</div>}
      {hasMore && !loading && products.length > 0 && (
        <div className="more-btn-wrap">
          <button className="more-btn" onClick={handleMore} disabled={loading}>
            더보기
          </button>
        </div>
      )}
    </div>
  );
};

export default Recommended;
